var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=Error, colour=NeturalHoverSelected, htmlTag=img, assetKey=Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "content1",
    x: 10.5106,
    y: 9.5238,
    width: 4.36487,
    height: 10.6443,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "content2",
    d: "M6.20496 20.1682C4.97242 20.1682 4.20273 18.8332 4.82027 17.7665L11.3083 6.55988C11.9246 5.49542 13.4614 5.49542 14.0777 6.55988L20.5657 17.7665C21.1833 18.8332 20.4136 20.1682 19.181 20.1682H6.20496ZM12.693 17.6418C12.9316 17.6418 13.1317 17.561 13.2934 17.3993C13.4545 17.2382 13.5351 17.0383 13.5351 16.7997C13.5351 16.5611 13.4545 16.3613 13.2934 16.2002C13.1317 16.0385 12.9316 15.9576 12.693 15.9576C12.4544 15.9576 12.2545 16.0385 12.0934 16.2002C11.9317 16.3613 11.8509 16.5611 11.8509 16.7997C11.8509 17.0383 11.9317 17.2382 12.0934 17.3993C12.2545 17.561 12.4544 17.6418 12.693 17.6418ZM11.8509 14.2734C11.8509 14.7385 12.2279 15.1155 12.693 15.1155C13.1581 15.1155 13.5351 14.7385 13.5351 14.2734V11.7471C13.5351 11.282 13.1581 10.905 12.693 10.905C12.2279 10.905 11.8509 11.282 11.8509 11.7471V14.2734Z",
    fill: "#CC333D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.24d1e7d6a06fc7c6697dc55f00e89399.svg";
export { ForwardRef as ReactComponent };